import { shouldPolyfill } from "@formatjs/intl-getcanonicallocales/should-polyfill";

export async function polyfillIntlGetCanonicalLocales() {
  if (shouldPolyfill()) {
    await import("@formatjs/intl-getcanonicallocales/polyfill");
  }
}
